module.exports = __webpack_public_path__ + "static/media/logo-removebg-preview.236a3fe6.png";